//srv_show v.1.1.1 from 04.06.2023

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
			(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.SRV_Show = factory());
}(this, (function () {
	'use strict';

	/**
	 * SRV_Show 1.0.3 data 04.05.23
	 * Copyright 2023 Sergey Chumachenko
	 */
	var srv_obj;

	// Default settings
	const defaults = {
		selector: '.srv_show',
		proxy: '',
		scroll: null,
		centered: null,
		toggle: 'modal',
		onInit: function () { }, // Return: plugin obj
	};

	// Initialize Plugin
	function _init(obj) {
		if (obj.settings.onInit && typeof obj.settings.onInit === 'function') {
			obj.settings.onInit(obj);
		}

		// Сохраняем настройку первого вызова плагина для показа модального окна, сформированного "на лету" по <a onClick=srv_show()>
		// Для такого вызова нет общих настроек obj и для работы используют настройками (obj = srv_obj). Это устаревший вариант и
		// рекомендуется использовать <button data-kmk-toggle="modal" data-kmk-target="#modal" data-kmk-url="https://..."
		//if (!(type srv_obj !== 'object' && srv_obj !== null)) srv_obj = obj;
		if (typeof srv_obj === 'undefined') srv_obj = obj;

		// Activate button for modal
		if (obj.settings.toggle == 'modal') {
			var btns = document.querySelectorAll('button')
			btns.forEach(function (btn) {
				if (btn.getAttribute('data-kmk-toggle') == 'modal') {
					let target = btn.getAttribute('data-kmk-target');
					if (/^#/.test(target)) {
						kmkCMSutil.addHandler(btn, 'click', _show_on_btn(null, obj));
					}
				}
			});
		}

		// Create fone layer
		_create_fone(obj);
	}
	function _create_modal(obj) {
		// Modal
		let objSrv = document.createElement("div");
		objSrv.id = "srv-show";
		objSrv.className = "srv-show";
		objSrv.classList.add("fade");
		objSrv.style.display = "none";

		// Modal Dialog
		let objSrvDialog = document.createElement("div");
		objSrvDialog.className = "srv-show__dialog";
		if (obj.settings.scroll) objSrvDialog.classList.add("srv-show__scrollable");
		if (obj.settings.centered) objSrvDialog.classList.add("srv-show__centered");

		// Content layer
		let objSrvShow = document.createElement("div");
		objSrvShow.className = "srv-show__content";
		objSrvDialog.appendChild(objSrvShow);
		obj.elements.modal.objSrvShow = objSrvShow;

		// Preloader layer
		let objSrvShowPrl = document.createElement("div");
		objSrvShowPrl.className = "srv-show__loader";
		objSrvDialog.appendChild(objSrvShowPrl);
		obj.elements.modal.objSrvShowPrl = objSrvShowPrl;

		// Header в Content
		let obj_header = document.createElement("div");
		obj_header.className = "srv-show__header";
		objSrvShow.appendChild(obj_header);

		// Кнопка в Header
		let objSrvShow_cls = document.createElement("button");
		objSrvShow_cls.className = "btn-close";
		obj_header.appendChild(objSrvShow_cls);
		obj.elements.modal.objSrvShow_cls = objSrvShow_cls;

		// Сообщение в Content
		let objSrvShow_body = document.createElement("div");
		objSrvShow_body.className = "srv-show__body";
		objSrvShow.appendChild(objSrvShow_body);
		obj.elements.modal.objSrvShow_body = objSrvShow_body;

		// Footer в Content
		let obj_footer = document.createElement("div");
		obj_footer.className = "srv-show__footer";
		objSrvShow.appendChild(obj_footer);

		// Кнопка "Закрыть" в Footer
		let objSrvShow_btn = document.createElement("button");
		objSrvShow_btn.type = "button";
		objSrvShow_btn.className = "btn";
		objSrvShow_btn.setAttribute('data-kmk-dismiss', 'modal');
		objSrvShow_btn.innerText = "Закрыть";
		obj_footer.appendChild(objSrvShow_btn);
		obj.elements.modal.objSrvShow_btn = objSrvShow_btn;

		objSrv.appendChild(objSrvDialog);
		obj.elements.modal.objSrvDialog = objSrvDialog;

		document.body.appendChild(objSrv);
		obj.elements.modal.objSrv = objSrv;
	}
	function _create_fone(obj) {
		// Fone fade layer
		let objSrvShowFon = document.querySelector('#srv-show__backdrop');
		if (!objSrvShowFon) {
			objSrvShowFon = document.createElement("div");
			objSrvShowFon.className = "srv-show__backdrop";
			objSrvShowFon.id = "srv-show__backdrop";
			objSrvShowFon.classList.add("fade");
			objSrvShowFon.style.display = "none";
			document.body.appendChild(objSrvShowFon);
		}
		obj.elements.fone = objSrvShowFon;
	}

	function _show_off(obj) {
		return function event(e) {
			if (obj.elements.modal.objSrvDialog && e.target !== obj.elements.modal.objSrvDialog && !obj.elements.modal.objSrvDialog.contains(e.target)) _close_modal(obj);
		}
	}
	function _show_off_btn(obj) {
		return function event(e) {
			_close_modal(obj);
		}
	}
	function _show_on_btn(url, obj) {
		return function (e) {
			let target = e.currentTarget.getAttribute('data-kmk-target');
			obj.target = (/^#/.test(target)) ? target : '';

			let url = e.currentTarget.getAttribute('data-kmk-url');
			obj.url = url;

			_show_on(url, obj);
		}
	}
	function _show_on(url, obj) {
		if (obj && obj.target) {
			obj.elements.modal.objSrv = document.querySelector(obj.target);
			_elements(obj);
		} else {
			// Программа запущена по onClick тега <a>
			obj = srv_obj;
			obj.elements.modal.objSrv = document.querySelector('#srv-show');
			if (!obj.elements.modal.objSrv) {
				_create_modal(obj);
			} else {
				_elements(obj);
			}
		}

		//scrSize = kmkCMSutil.screenSize();
		//sclXY = kmkCMSutil.getScrollXY();

		if (url && /^(http(s?)):\/\/|(\.)\//i.test(url)) {
			obj.url = _geturl(url + "&htmhead=0", obj.settings.proxy);
		}
		if (obj.elements.modal.objSrvDialog) kmkCMSutil.addHandler(obj.elements.modal.objSrvDialog, 'click', _emptyHandler);
		if (obj.elements.modal.objSrv) kmkCMSutil.addHandler(obj.elements.modal.objSrv, 'click', _show_off(obj));
		if (obj.elements.fone) kmkCMSutil.addHandler(obj.elements.fone, 'click', _show_off(obj));
		if (obj.elements.modal.objSrvShow_cls) kmkCMSutil.addHandler(obj.elements.modal.objSrvShow_cls, 'click', _show_off_btn(obj));
		if (obj.elements.modal.objSrvShow_btn) kmkCMSutil.addHandler(obj.elements.modal.objSrvShow_btn, 'click', _show_off_btn(obj));

		document.body.classList.add('srvShow-open');
		obj.elements.modal.objSrv.style.display = 'block';

		if (obj.elements.fone) {
			obj.elements.fone.classList.add("show");
			obj.elements.fone.style.display = 'block';
		}

		if (obj.url) {
			kmkCMS.loadXMLDoc(obj.url, obj.elements.modal.objSrvShow_body, null, _screen.bind(null, obj));
		} else {
			if (url) obj.elements.modal.objSrvShow_body.innerHTML = url;
			_screen(obj);
		}
	}
	function _emptyHandler(e) {
		return;
	}
	function _elements(obj) {
		if (!obj.elements.modal.objSrv) return;
		obj.elements.modal.objSrvDialog = obj.elements.modal.objSrv.querySelector('.srv-show__dialog');
		obj.elements.modal.objSrvShow = obj.elements.modal.objSrvDialog.querySelector('.srv-show__content');
		obj.elements.modal.objSrvShowPrl = obj.elements.modal.objSrvDialog.querySelector('.srv-show__loader');
		obj.elements.modal.objSrvShow_body = obj.elements.modal.objSrvShow.querySelector('.srv-show__body');

		obj.elements.modal.objSrvShow_cls = obj.elements.modal.objSrvShow.querySelector('.srv-show__header button.btn-close');

		let btns = obj.elements.modal.objSrvShow.querySelectorAll('.srv-show__footer button');
		btns.forEach(function (btn) {
			if (btn.getAttribute('data-kmk-dismiss') == 'modal') {
				obj.elements.modal.objSrvShow_btn = btn;
			}
		});
	}

	function _screen(obj) {
		if (obj.elements.modal.objSrvShow_body.innerHTML) {
			_show_modal(obj);
		} else {
			setTimeout(function () { _close_modal(obj) }, 1000);
		}
	}
	function _show_modal(obj) {
		obj.elements.modal.objSrv.classList.add("show");
	}
	function _close_modal(obj) {
		document.body.classList.remove('srvShow-open');
		obj.elements.modal.objSrv.classList.remove('show');
		obj.elements.modal.objSrv.style.display = 'none';

		if (obj.url) obj.elements.modal.objSrvShow_body.innerHTML = '';

		//objSrvShowClose.style.display = 'none';
		//objSrvShowPrl.style.display = 'none';

		obj.elements.fone.style.display = 'none';

		if (obj.elements.modal.objSrvDialog) kmkCMSutil.removeHandler(obj.elements.modal.objSrvDialog, 'click', _emptyHandler);
		if (obj.elements.modal.objSrv) kmkCMSutil.removeHandler(obj.elements.modal.objSrv, 'click', _show_off.event);
		if (obj.elements.fone) kmkCMSutil.removeHandler(obj.elements.fone, 'click', _show_off.event);
		if (obj.elements.modal.objSrvShow_cls) kmkCMSutil.removeHandler(obj.elements.modal.objSrvShow_cls, 'click', _show_off_btn.event);
		if (obj.elements.modal.objSrvShow_btn) kmkCMSutil.removeHandler(obj.elements.modal.objSrvShow_btn, 'click', _show_off_btn.event);

		//Clear obj
		obj.elements.modal = {};
		obj.target = null;
		obj.url = null;
	}
	function _geturl(script, proxy) {
		return (proxy) ? proxy + encodeURIComponent(script) : script;
	}

	// SRV_SMarket constructor
	const SRV_Show = function (options) {
		// Merge user options with defaults
		var settings = kmkCMSutil.extend(defaults, options || {});

		const srv_show = {
			target: null,
			url: null,
			show_on: _show_on,
			settings: settings,
			elements: {
				modal: {},
				fone: null,
			},
		};

		_init(srv_show);

		// Public APIs
		return srv_show;
	};
	return SRV_Show;
})));